import React, { useContext, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IoAlertCircleOutline } from "react-icons/io5";

const Donar = () => {
    const { currency } = useContext(ShopContext);
    const location = useLocation();
    const navigate = useNavigate();

    // Retrieve totalDonationAmount and tipAmount from location state
    const totalDonationAmount = location.state?.totalDonationAmount || 0;
    const tipAmount = location.state?.tipAmount || 0; // Get tipAmount if available

    // Initialize donation amount based on props if needed
    const [donationAmount, setDonationAmount] = useState(totalDonationAmount);

    // Handle proceeding to payment
    const handleProceedToPay = () => {
        navigate('/checkout', { state: { totalDonationAmount: donationAmount, tipAmount } }); // Pass total amount and tip to Checkout
    };

    return (
        <div>
            <div className="checkout_section pt-3 pb-5 pt-md-5">
                <div className="cart_heading" style={{ minHeight: '125px' }}>
                    <div className="container">
                        <div className="row g-2 d-flex align-items-center justify-content-center">
                            <div className="item-box col-lg-8 col-xl-6 d-flex justify-content-center">
                                <div className="col-4">
                                    <div className="gateway_process position-relative overflow-hidden text-center">
                                        <div className="numbr-box bg-warning">01</div>
                                        <div className="process-name mt-2">Donation Details</div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="gateway_process position-relative overflow-hidden text-center">
                                        <div className="numbr-box bg-warning">02</div>
                                        <div className="process-name mt-2">Personal Details</div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="gateway_process position-relative overflow-hidden text-center">
                                        <div className="numbr-box bg-white">03</div>
                                        <div className="process-name mt-2">Payment Gateway</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="cart-box">
                                <div className="send-mgs pb-4 text-center text-sm-start">
                                    <h2 className="mb-3">Enter your Details</h2>
                                    <p>
                                        Users will also receive donation drive details on WhatsApp and Mail provided below.
                                    </p>
                                </div>
                                <form action="#" method="post">
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label htmlFor="firstName" className="form-label">First Name*</label>
                                            <input type="text" className="form-control" id="firstName" name="first_name" required />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label htmlFor="lastName" className="form-label">Last Name*</label>
                                            <input type="text" className="form-control" id="lastName" name="last_name" required />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label htmlFor="email" className="form-label">Email*</label>
                                            <input type="email" className="form-control" id="email" name="email" required />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label htmlFor="whatsapp" className="form-label">Whatsapp Number*</label>
                                            <div className="input-group">
                                                <input type="text" className="form-control border-start-0" id="whatsapp" name="whatsapp" required />
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label htmlFor="address" className="form-label">Address*</label>
                                            <input type="text" className="form-control" id="address" name="address" required />
                                        </div>
                                        

                                            <div className="col-md-6 d-flex align-items-start ">
                                <div className="me-2" style={{ flex: 0.6 }}>
                                    <label htmlFor="panOptions" className="form-label">PAN Card Options</label>
                                    <select className="form-control" id="panOptions" name="pan_options" style={{ height: '100%' }}>
                                        <option value="" disabled>Select an option</option>
                                        <option value="verified">PAN Card (Tax Benefit)</option>
                                        <option value="pending">Aadhar Card</option>
                                        <option value="rejected">Voter ID</option>
                                        <option value="rejected">SSN/TIN</option>

                                    </select>
                                </div>

                                <div style={{ flex: 1 }}>
                                    <label htmlFor="panCard" className="form-label">PAN Card</label>
                                    <input type="text" className="form-control" id="panCard" name="pan_card" style={{ height: '100%' }} />
                                </div>
                            </div>

                                    </div>
                                </form>
                            </div>
                            <div className="common-details">
                              <p><IoAlertCircleOutline/>To claim an 80G certificate or tax redemption for your donation, provide your PAN card information.</p>
                             </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="card-box send-mgs">
                                <h2 className="mb-4">Payment Details</h2>
                                <div className="card-box-item d-flex justify-content-between">
                                    <p>Special Request Charge</p>
                                    <span className="price">{currency} 0</span>
                                </div>
                                <div className="card-box-item d-flex justify-content-between">
                                    <p>Tip Amount</p>
                                    <span className="price">{currency} {tipAmount.toFixed(2)}</span>
                                </div>
                                <div className="card-box-item d-flex justify-content-between">
                                    <p>Donated Amount</p>
                                    <span className="price">{currency} {donationAmount.toFixed(2)}</span>
                                </div>
                                <div className="card-box-item d-flex justify-content-between border-top border-dark mt-4 pt-3">
                                    <strong>Total Donation Amount</strong>
                                    <strong>{currency} {(totalDonationAmount + tipAmount).toFixed(2)}</strong>
                                </div>
                            </div>
                            <div className="btn-box d-flex align-items-center justify-content-between">
                                <Link to='/checkout'
                                    className="btn btn-outline-warning w-100 pay-btn shadow-none me-1 me-sm-3 rounded-4 d-flex align-items-center justify-content-center"> Back</Link>
                                <button className="btn btn-primary w-100 pay-btn shadow-none rounded-4 ms-1 ms-sm-3" onClick={handleProceedToPay}>Proceed to Pay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Donar;
